import { StarterCallback } from "@/starter";
import { createI18n } from "vue-i18n";
import * as en from "./messages/en";
import * as cnZH from "./messages/cnZH";
// import * as jaJP from "./messages/jaJP";
// import * as cnTW from "./messages/cnTW";
// import * as itIT from "./messages/itIT";
// import * as deDE from "./messages/deDE";
import { App } from "vue";
let app: App;

const _setApp = (vueInstance: App) => (app = vueInstance);

type LanguageKey = User.PortalLanguage;
type LanguageValue = typeof en | typeof cnZH;
// | typeof jaJP
// | typeof cnTW
// | typeof itIT
// | typeof deDE;
/// todo add check logic
const getMessages = (): Partial<Record<LanguageKey, LanguageValue>> => {
  return {
    "en-US": en,
    "zh-CN": cnZH,
    // "ja-JP": jaJP,
    // "zh-TW": cnTW,
    // "it-IT": itIT,
    // "de-DE": deDE,
  };
};

const messages = getMessages();
export const i18n = createI18n({
  locale: "zh-CN",
  fallbackLocale: "zh-CN",
  messages,
});

export const t = i18n.global.t;
export const tc = i18n.global.tc;
export const te = i18n.global.te;
export const tm = i18n.global.tm;

export const tFactory =
  (prefix: string) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (name: string, ...rest: any[]) => {
    return Array.isArray(rest) && rest.length > 0
      ? i18n.global.t(`${prefix}${name}`, ...(rest as []))
      : i18n.global.t(`${prefix}${name}`);
  };

export const tcFactory =
  (prefix: string) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (name: string, count: number, ...rest: any[]) => {
    return Array.isArray(rest) && rest.length > 0
      ? i18n.global.tc(`${prefix}${name}`, count, ...(rest as []))
      : i18n.global.tc(`${prefix}${name}`, count, rest);
  };

export const getBrowserLanguage = () => {
  const lang = (navigator.language ?? "").toLowerCase();
  if (/^zh-tw/.test(lang)) return "zh-TW";
  if (/^zh\b/.test(lang)) return "zh-CN";
  if (/^de\b/.test(lang)) return "de-DE";
  if (/^en\b/.test(lang)) return "en-US";
  if (/^es\b/.test(lang)) return "es-ES";
  if (/^fr\b/.test(lang)) return "fr-FR";
  if (/^it\b/.test(lang)) return "it-IT";
  if (/^ja\b/.test(lang)) return "ja-JP";

  return "en-US";
};

/**
 * 初始化i18n
 */
export const initI18n: StarterCallback = (app) => {
  app.use(i18n);
  const store = app.config.globalProperties.$store;

  const lang = getBrowserLanguage();
  setCurrentLanguage(lang);
};

export const availableLanguages = i18n.global.availableLocales;

export const setCurrentLanguage = (language: LanguageKey) => {
  if (language !== i18n.global.locale) {
    i18n.global.locale = language;
  }
};

export const getCurrentLanguage = () => {
  return i18n.global.locale;
};

// 用连接带有引号的数组
export const i18nArrayJoin = (arrData: string[]) => {
  const language = i18n.global.locale;
  const defaultStr = `"${arrData.join('", "')}"`;
  const cnStr = `“${arrData.join("”，“")}”`;
  return language === "zh-CN" ? cnStr : defaultStr;
};
